export default "__VITE_ASSET__CAG23pOS__"